export const LOCATIONS = [
  'Select location',
  'Amsterdam',
  'Bangkok',
  'Belgrade',
  'Berlin',
  'Budapest',
  'Dubai',
  'Edinburgh',
  'Eindhoven',
  'Farmington Hills',
  'Gent',
  'Hannover',
  'Jakarta',
  'Lebanon',
  'Lodz',
  'London',
  'Madrid',
  'Milan',
  'Moscow',
  'Munich',
  'Other',
  'Paris',
  'Poznan',
  'Pune',
  'Remote',
  'San Jose',
  'Sao Paulo',
  'Seoul',
  'Shanghai',
  'Sydney',
  'Taipei',
  'Tokyo',
  'Turin',
  'Warsaw',
];

// business-unit-name annotation → umbrella label mapping:
//   graph.microsoft.com/business-unit-name: MAPS              --> Maps Engineering
//   graph.microsoft.com/business-unit-name: Product Engineering --> Product Engineering
//   graph.microsoft.com/business-unit-name: SHARED SERVICES   --> Corporate Services
//   graph.microsoft.com/business-unit-name: CONSUMER          --> CRO Organization
//   graph.microsoft.com/business-unit-name: CRO               --> CRO Organization

const MAPS_ENGINEERING_UNITS = [
  'ADAS & ADS',
  'Directions',
  'Floating car data',
  'Geo intelligence',
  'Map I/O',
  'Maps Platform & Operations',
  'Places',
];

const PRODUCT_ENGINEERING_UNITS = [
  'Product management',
  'UX & Research',
  'Product & Business Operations',
  'Navigation',
  'Customer Experience',
  'Search',
  'Safety & Security',
  'Navigation intelligence',
  'Platform engineering',
];

const CORPORATE_SERVICES_UNITS = [
  'People',
  'Marketing',
  'Finance',
  'Legal',
  'IT',
  'Facilities',
];

const CRO_ORGANIZATION_UNITS = [
  'Sales',
  'Value & Bid management',
  'Solutions & Sales enablement',
  'Product Marketing management',
  'Sales & marketing analytics',
  'Consumer Sales & marketing',
];

export const UPDATED_PRODUCT_UNITS = [
  'Select unit',
  ...MAPS_ENGINEERING_UNITS,
  ...PRODUCT_ENGINEERING_UNITS,
  ...CORPORATE_SERVICES_UNITS,
  ...CRO_ORGANIZATION_UNITS,
];

/** Returns a filtered subset of product units based on the user's
 *  `graph.microsoft.com/business-unit-name` annotation value.
 *  Falls back to the full list when the value is absent or unrecognised. */
export function getFilteredProductUnits(businessUnitName?: string): string[] {
  const normalised = (businessUnitName ?? '').trim().toUpperCase();
  let subset: string[];
  if (normalised === 'MAPS') {
    subset = MAPS_ENGINEERING_UNITS;
  } else if (normalised === 'PRODUCT ENGINEERING') {
    subset = PRODUCT_ENGINEERING_UNITS;
  } else if (normalised === 'SHARED SERVICES') {
    subset = CORPORATE_SERVICES_UNITS;
  } else if (normalised === 'CONSUMER' || normalised === 'CRO') {
    subset = CRO_ORGANIZATION_UNITS;
  } else {
    return UPDATED_PRODUCT_UNITS;
  }
  return ['Select unit', ...subset];
}

export const EXTENDED_JOB_FAMILIES = [
  'Select job family',
  'Accounting',
  'Administration',
  'Applications',
  'Architecture',
  'Bid Management',
  'Business Development',
  'Communication',
  'Contractor/Consultant',
  'Controlling',
  'Customer Care',
  'Customer Solution Management',
  'Cyber Security',
  'Data Science',
  'Facilities',
  'Finance Specialists',
  'General Human Resources',
  'General Legal',
  'General Marketing',
  'General Supply Chain',
  'Intern',
  'IT Support',
  'Operations',
  'Other',
  'Product Design',
  'Product Owner',
  'Product Management',
  'Project Management',
  'Program management',
  'Quality Assurance',
  'Software Engineering',
  'Sourcing',
];

export const HOODIE_SIZE_OPTIONS = [
  'Select your hoodie size',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '3XL',
];

// Temporary List. We need to figure out a programmatic way to get this, or have a hard-coded list closer to the event
export const PRODUCT_MANAGER_OPTIONS = [
  '',
  'ABDELJALIL KARAM',
  'Abhishek Saikia',
  'Akshay Borawake',
  'Aleksandra Ferdzyn-Grzelak',
  'Aleksandra Jatczak',
  'Alexander Bregman',
  'Alina Kmiecik',
  'Alina Oancea',
  'Andre Gatorano',
  'Anna Karyakina',
  'Anton Hordiienko',
  'Arkadiusz Milek',
  'Artabaz Shams',
  'Artem Kriuchkov',
  'Ashmita Chaudhury',
  'BarisCan Kara',
  'Bartosz Kokocinski',
  'Bogumila Keur-Sobolewska',
  'Bram Vanmeirhaeghe',
  'Carl Meert',
  'Chris Poppe',
  'Daan Duurkoop',
  'Daniel Caceiro',
  'Daniele Simione',
  'Danna Jia',
  'Daria Turobos',
  'David Lambright',
  'Dmitry Kan',
  'Dominika Bennink-Spolnik',
  'Douglas Gilmour',
  'Drew Meehan',
  'Dries DeMeyer',
  'Edwin Kools',
  'Emily Crook',
  'Erwin Perremans',
  'Eugene Ter-Avakyan',
  'Eva Jennings',
  'Felix Koenig',
  'Feyona VanMiddelaar',
  'Francesco Perfetto',
  'Frank Palinkas',
  'Galina Kuklenko',
  'Gianluca Brugnoli',
  'Gregoire Follain',
  'Hanno Spijker',
  'Hitesh Jolly',
  'Illia Matviienko',
  'Ilse Vitse',
  'Ioana Kanda',
  'Ioanna Kostara',
  'Joao LARANJEIRA',
  'Johan Land',
  'Jokin Zunzunegui',
  'Joost Pennings',
  'Joost Voogt',
  'Jose Rojas',
  'JoseLuis Munoz',
  'Juniper Gujral',
  'Justin Crowell',
  'Karen VanAudenhaege',
  'Khrystyna Sosiak',
  'Kris Engelen',
  'Kris Kobylinski',
  'KristinaAntonia Vuletic',
  'Laurens Feenstra',
  'Leo Sei',
  'Leon VanHelvoort',
  'Lewis Mowatt',
  'Liandi Badenhorst',
  'Lyle Baumgarten',
  'Maciej Kitowski',
  'Marek Kaczorowski',
  'Mario Aigner',
  'Matteo Mecucci',
  'Mattijs Kersten',
  'Maurits Hol',
  'Mehmet Incaz',
  'Michael Hausen',
  'Mike Gilbert',
  'Milkent Samsurya',
  'MinhHai Nguyen',
  'Monika Pepikj',
  'Mostafa Rahmani',
  'Nikhil Kattani',
  'Nurit Dienes',
  'Ozlem Bellikan',
  'Parisa KhanipourRoshan',
  'Pascal Kersic',
  'Patricia FuentesMontoya',
  'Paul Hesen',
  'Rajneeta Srivastav',
  'Ralf-Peter Schaefer',
  'Raquel VanKampen',
  'Reza MohammadiGhayeghchi',
  'Richard Jonkman',
  'Rob VanSeggelen',
  'Roger Chan',
  'Rolf Dorland',
  'Ruben Woelders',
  'Ruth MartinMarco',
  'Sabrina FernandezMiras',
  'Sarah Ni',
  'Sebastien Salles',
  'Shaun Mulligan',
  'Shirish Kasa',
  'Shrutika Sainani',
  'Shubham Bhusari',
  'Siavash Shakeri',
  'Silvia Longo',
  'Simon Stewart',
  'Sonja Radenkovic',
  'Stuti Srivastava',
  'Suzanne Szuba',
  'Tair Bilyalov',
  'Tetiana Kot',
  'Thiagarajan Iyer',
  'Thomas Banks',
  'Tiago Moreiras',
  'Timo Melman',
  'Tomasz Busiak',
  'Tomasz Ciniewski',
  'Tomasz Kowalczyk',
  'Tomasz Szczepanek',
  'Tommaso Lombardi',
  'Vedika Agarwal',
  'Vikram Salunke',
  'Viktorija Ristova',
  'Vladislav Mazur',
  'Wendy VanThiel',
  'Willem Strijbosch',
  'Wouter Vermeulen',
  'Wouter Weerkamp',
  'Yasemin Kisa',
  'Yuval Kantor',
  'Zeynep Kantarci',
];

// list of PM emails
export const PRODUCT_MANAGER_EMAILS = [
  'Nurit.Dienes@tomtom.com',
  'Wouter.Vermeulen@tomtom.com',
  'Alina.Oancea@tomtom.com',
  'MinhHai.Nguyen@tomtom.com',
  'Tomasz.Ciniewski@tomtom.com',
  'Arkadiusz.Milek@tomtom.com',
  'Kris.Kobylinski@tomtom.com',
  'Daniele.Simione@tomtom.com',
  'Maciej.Kitowski@tomtom.com',
  'ABDELJALIL.KARAM@tomtom.com',
  'Sarah.Ni@tomtom.com',
  'Anton.hordiienko@tomtom.com',
  'Shirish.Kasa@tomtom.com',
  'Justin.Crowell@tomtom.com',
  'Hitesh.Jolly@tomtom.com',
  'Zeynep.Kantarci@tomtom.com',
  'Ilse.Vitse@tomtom.com',
  'Siavash.Shakeri@tomtom.com',
  'Mario.Aigner@tomtom.com',
  'Raquel.vanKampen@tomtom.com',
  'BarisCan.Kara@tomtom.com',
  'Danna.Jia@tomtom.com',
  'Juniper.Gujral@tomtom.com',
  'Tomasz.Kowalczyk@tomtom.com',
  'David.Lambright@tomtom.com',
  'Jose.Rojas@tomtom.com',
  'Frank.Palinkas@tomtom.com',
  'Khrystyna.Sosiak@tomtom.com',
  'Alina.Kmiecik@tomtom.com',
  'Tommaso.Lombardi@tomtom.com',
  'Gregoire.Follain@tomtom.com',
  'Carl.Meert@tomtom.com',
  'Silvia.Longo@tomtom.com',
  'Mehmet.Incaz@tomtom.com',
  'Thomas.Banks@tomtom.com',
  'Pascal.Kersic@tomtom.com',
  'daan.duurkoop@tomtom.com',
  'Jokin.Zunzunegui@tomtom.com',
  'Lewis.Mowatt@tomtom.com',
  'Lyle.Baumgarten@tomtom.com',
  'Eva.Jennings@tomtom.com',
  'Joost.Pennings@tomtom.com',
  'Felix.Koenig@tomtom.com',
  'Hanno.Spijker@tomtom.com',
  'Galina.Kuklenko@tomtom.com',
  'Michael.Hausen@tomtom.com',
  'Paul.Hesen@tomtom.com',
  'Ralf-Peter.Schaefer@tomtom.com',
  'Yasemin.Kisa@tomtom.com',
  'Sonja.Radenkovic@tomtom.com',
  'Willem.Strijbosch@tomtom.com',
  'Liandi.Badenhorst@tomtom.com',
  'Emily.Crook@tomtom.com',
  'Johan.Land@tomtom.com',
  'Laurens.Feenstra@tomtom.com',
  'Leo.Sei@tomtom.com',
  'Suzanne.Szuba@tomtom.com',
  'Parisa.KhanipourRoshan@tomtom.com',
  'Gianluca.Brugnoli@tomtom.com',
  'Dominika.Bennink-Spolnik@tomtom.com',
  'Matteo.Mecucci@tomtom.com',
  'Sebastien.Salles@tomtom.com',
  'Ruben.Woelders@tomtom.com',
  'Tiago.Moreiras@tomtom.com',
  'Eugene.Ter-Avakyan@tomtom.com',
  'Maurits.Hol@tomtom.com',
  'Rob.vanSeggelen@tomtom.com',
  'Patricia.FuentesMontoya@tomtom.com',
  'Reza.MohammadiGhayeghchi@tomtom.com',
  'Shubham.Bhusari@tomtom.com',
  'Anna.Karyakina@tomtom.com',
  'Ioana.Kanda@tomtom.com',
  'Thiagarajan.Iyer@tomtom.com',
  'Artabaz.Shams@tomtom.com',
  'Ashmita.Chaudhury@tomtom.com',
  'Rolf.Dorland@tomtom.com',
  'Leon.vanHelvoort@tomtom.com',
  'Aleksandra.Ferdzyn-Grzelak@tomtom.com',
  'Viktorija.Ristova@tomtom.com',
  'Feyona.vanMiddelaar@tomtom.com',
  'Drew.Meehan@tomtom.com',
  'Andre.Gatorano@tomtom.com',
  'Timo.Melman@tomtom.com',
  'Wendy.vanThiel@tomtom.com',
  'Erwin.Perremans@tomtom.com',
  'Yuval.Kantor@tomtom.com',
  'Abhishek.Saikia@tomtom.com',
  'Rajneeta.Srivastav@tomtom.com',
  'Daria.Turobos@tomtom.com',
  'Karen.VanAudenhaege@tomtom.com',
  'Artem.Kriuchkov@tomtom.com',
  'Mattijs.Kersten@tomtom.com',
  'Mostafa.Rahmani@tomtom.com',
  'Ruth.MartinMarco@tomtom.com',
  'Daniel.Caceiro@tomtom.com',
  'Shaun.Mulligan@tomtom.com',
  'Bram.Vanmeirhaeghe@tomtom.com',
  'Vikram.Salunke@tomtom.com',
  'Tomasz.Szczepanek@tomtom.com',
  'Akshay.Borawake@tomtom.com',
  'Ioanna.Kostara@tomtom.com',
  'Vedika.Agarwal@tomtom.com',
  'Illia.Matviienko@tomtom.com',
  'Milkent.Samsurya@tomtom.com',
  'Roger.Chan@tomtom.com',
  'Simon.Stewart@tomtom.com',
  'JoseLuis.Munoz@tomtom.com',
  'Kris.Engelen@tomtom.com',
  'Richard.Jonkman@tomtom.com',
  'Dries.DeMeyer@tomtom.com',
  'Chris.Poppe@tomtom.com',
  'Francesco.Perfetto@tomtom.com',
  'Sabrina.FernandezMiras@tomtom.com',
  'Joost.Voogt@tomtom.com',
  'Bartosz.Kokocinski@tomtom.com',
  'Bogumila.Keur-Sobolewska@tomtom.com',
  'Tomasz.Busiak@tomtom.com',
  'Wouter.Weerkamp@tomtom.com',
  'Dmitry.Kan@tomtom.com',
  'Nikhil.Kattani@tomtom.com',
  'Alexander.Bregman@tomtom.com',
  'Vladislav.Mazur@tomtom.com',
  'Mike.Gilbert@tomtom.com',
  'Edwin.Kools@tomtom.com',
  'Douglas.Gilmour@tomtom.com',
  'Joao.LARANJEIRA@tomtom.com',
  'Aleksandra.Jatczak@tomtom.com',
  'Monika.Pepikj@tomtom.com',
  'Marek.Kaczorowski@tomtom.com',
  'Tetiana.Kot@tomtom.com',
  'ozlem.bellikan@tomtom.com',
  'Tair.Bilyalov@tomtom.com',
  'Stuti.Srivastava@tomtom.com',
  'Shrutika.Sainani@tomtom.com',
  'KristinaAntonia.Vuletic@tomtom.com',
];

export const GOODIES_PICKUP_OFFICE_OPTIONS = [
  'Select Goodies Pickup Office',
  'I work fully remotely and I will fill the Goodies Delivery Address field',
  'Amsterdam',
  'Auckland',
  'Bangkok',
  'Belgrade',
  'Berlin',
  'Budapest',
  'Dubai',
  'Edinburgh',
  'Eindhoven',
  'Farmington Hills, MI',
  'Ghent',
  'Hannover',
  'Jakarta',
  'Kuala Lumpur',
  'Lebanon, NH',
  'Łódź',
  'London',
  'Madrid',
  'Milan',
  'Moscow',
  'Munich',
  'Nagoya',
  'Paris',
  'Poznan',
  'Pune',
  'San Jose, CA',
  'Sao Paulo',
  'Seoul',
  'Shanghai',
  'Sydney',
  'Taipei',
  'Tokyo',
  'Turin',
];

export const WTH_EXPERTISE_OPTIONS = [
  'Select your level of expertise with What the Hack',
  'Starter - 0 experience',
  'Intermediate - Joined 1 Hackathon',
  'Advanced - Joined 2+ Hackathon',
];

export const SELF_ASSESSMENT_SCORE_OPTIONS = ['0', '1', '2', '3', '4', '5'];
export const JURY_ASSESSMENT_SCORE_OPTIONS = [
  '0',
  '1',
  '1.1',
  '1.2',
  '1.3',
  '1.4',
  '1.5',
  '1.6',
  '1.7',
  '1.8',
  '1.9',
  '2',
  '2.1',
  '2.2',
  '2.3',
  '2.4',
  '2.5',
  '2.6',
  '2.7',
  '2.8',
  '2.9',
  '3',
  '3.1',
  '3.2',
  '3.3',
  '3.4',
  '3.5',
  '3.6',
  '3.7',
  '3.8',
  '3.9',
  '4',
  '4.1',
  '4.2',
  '4.3',
  '4.4',
  '4.5',
  '4.6',
  '4.7',
  '4.8',
  '4.9',
  '5',
];
